// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__ypHp8","input":"Input_input__QfJb0","label":"Input_label__SWinQ","error":"Input_error__XC2cB"};